import { FaEye } from "react-icons/fa";

export const Proj2 = () => {
  return (
    <article className="relative rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-500 bg-white/5 backdrop-blur-sm">
      {/* Project Image */}
      <img src="/img/projects/proctorpal.png" alt="Offline Invigilation App" className="w-full h-64 md:h-72 object-cover rounded-t-2xl" loading="lazy" />

      {/* Project Info */}
      <div className="p-6 space-y-4">
        <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">Offline Invigilation App</h3>
        <p className="text-gray-600 text-lg leading-relaxed">The Offline Invigilation App allows invigilators to manage exam sessions seamlessly from their mobile devices. It enables attendance tracking, and reporting to ensure a secure and efficient offline examination process.</p>
        <div className="flex justify-center mt-4">
          <a href="https://play.google.com/store/apps/details?id=com.annconnect.proctorpal&hl=en" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-5 py-2 rounded-xl font-semibold text-white shadow-md bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 hover:scale-105 transition-transform duration-300" aria-label="View Offline Invigilation App on Google Play">
            <FaEye className="mr-2" /> View
          </a>
        </div>
      </div>
    </article>
  );
};
